module.exports = __webpack_public_path__ + "static/goodrx-desktop-283e3c3bacf9d5eb1c19cf17143d831f.png";